module.exports = __webpack_public_path__ + "static/img/bg-banner-case-detail-tunnel.fc304262.png";